






















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';
import { saveAs } from 'file-saver';

import { STORE_KEY, store } from './_store';
import { buildShiftFactWorkbook, shiftFactFilename, ShiftFactExportRow } from '../shiftFactXlsx';
import { STORE_KEY as SHIFT_DETAILS_STORE_KEY } from '../_store';

import ShiftAtomFactForm from './ShiftAtomFactForm/ShiftAtomFactForm.vue'
import ShiftAtomFactPrint from "./ShiftAtomFactPrint/ShiftAtomFactPrint.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'relatedFactsList', 'meta'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
      'remainsById', 'totals', 'rotateFacts'
    ]),
  },
  components: {
    ShiftAtomFactForm
  }
})
export default class ShiftAtomFact extends Vue {

  @Prop() documentId!: string;

  relatedFactsList!: any[];

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  sortByNumber(a: any, b: any, isArc: boolean) {
    console.log(a, b, isArc)
    const keyA = parseFloat(a.number);
    const keyB = parseFloat(b.number);
    const result = (keyA > keyB) ? 1 : ((keyA < keyB) ? -1 : 0)
    return result * (isArc ? 1 : -1)
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftAtomFactForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {
          plan_id: row.plan_id,
          mark_type: row.mark_type
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openPrintDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftAtomFactPrint,
      props: {
        factId: row.id,
        labelText: row.label_text,
        volumeType: row.volume_type
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }

  /**
   * Мастер смены: из документа смены ($_shift_details, join s:employees по shift.manager_id),
   * fallback — работник смены с ролью мастера.
   */
  public get shiftMasterName(): string {
    const detailsState: any = this.$store.state[SHIFT_DETAILS_STORE_KEY];
    const managerName = detailsState?.document?.manager_name;
    if (managerName) return managerName;
    const managerWorker = (detailsState?.workers || []).find((worker: any) => worker.is_manager);
    return managerWorker?.employee_name || '';
  }

  public get shiftDate(): string {
    const detailsState: any = this.$store.state[SHIFT_DETAILS_STORE_KEY];
    return detailsState?.document?.shift_date || '';
  }

  public get shiftTimesOfDay(): string {
    const detailsState: any = this.$store.state[SHIFT_DETAILS_STORE_KEY];
    return detailsState?.document?.times_of_day || '';
  }

  /** Шаблон линии смены (atom/vdp/custom/wash) для колонки «Линия» бланка */
  public get shiftTemplate(): string {
    const detailsState: any = this.$store.state[SHIFT_DETAILS_STORE_KEY];
    return detailsState?.document?.line_template || '';
  }

  /** Клиентский ExcelJS-экспорт бланка факта (заполняется вручную) */
  public async exportFactBlank() {
    // [FIX] «количество» — зарегистрированный факт («Кол-во выпущенного продукта,
    // шт», item.quantity = sfa.quantity), а не плановое значение партии (plan_quantity).
    const rows: ShiftFactExportRow[] = (this.relatedFactsList || []).map((item: any) => ({
      batch_number: item.number,
      product_name: item.product_name,
      container_name: item.fact_container_name || item.container_name,
      quantity: item.quantity,
    }));

    const doc = {
      kind: 'факт_розлива',
      shift_date: this.shiftDate,
      times_of_day: this.shiftTimesOfDay,
      master_name: this.shiftMasterName,
      template: this.shiftTemplate,
      rows,
    };

    if (process.env.NODE_ENV === 'development') {
      console.debug('[ShiftAtomFact] exportFactBlank: rows=', rows.length,
        ', master=', doc.master_name, ', shift_date=', doc.shift_date,
        ', times_of_day=', doc.times_of_day);
    }

    try {
      const buffer = await buildShiftFactWorkbook(doc);
      const filename = shiftFactFilename(doc);
      if (process.env.NODE_ENV === 'development') {
        console.debug('[ShiftAtomFact] exportFactBlank file=', filename,
          ', bytes=', buffer?.byteLength);
      }
      saveAs(new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }), filename);
      this.$buefy.toast.open('Файл выгружен');
    } catch (err) {
      console.error('[ShiftAtomFact] exportFactBlank error', err);
      this.$buefy.toast.open({
        type: 'is-warning',
        message: 'Не удалось выгрузить файл. Попробуйте позже.',
      });
    }
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }

  public copyPlan(row: any) {
    this.$buefy.dialog.prompt({
      message: `Сколько ведер отделить?`,
      inputAttrs: {
          type: 'number',
          step: "any",
          placeholder: 'Количество',
          min: 0,
          max: row.quantity,
      },
      confirmText: 'Раделить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/copyPlan`, {
          planId: row.plan_id,
          shiftId: this.documentId,
          number: row.number,
          value: parseInt(value),
        }).then(() => {
        this.$buefy.snackbar.open(`Запись успешно разделена`);
          this.handleParamsChange()
        })
      }
    })
  }

  setExctartTime(row: any, extract_time: any) {
    row.finalized = false;
    this.$store.dispatch(`${STORE_KEY}/setExctartTime`, {
      documentId: this.documentId,
      row,
      extract_time
    })
  }
}

